import React from "react";
import { Box, Button, Chip, Typography,Paper } from "@mui/material";
import { useNavigate ,useLocation} from "react-router-dom";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SecurityIcon from "@mui/icons-material/Security";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ShieldIcon from "@mui/icons-material/Shield";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import SelexSolNavbar from "./CommonC/SelexSolNavbar";
import { baseURL } from "../Config/config";


import probability from "../images/probability.png";
import selexpof1 from "../images/products/selexpof1.png";

import selexoracle from "../images/products/selexoracle.png";
import selexoracle1 from "../images/products/selexoracle1.png";

import hybrid from "../images/products/selexhazop.png";
import selexhazop1 from "../images/products/selexhazop1.png";

import selexpyramis from "../images/products/selexpyramis.png";
import selexpyramis1 from "../images/products/selexpyramis1.png";

import selexaim from "../images/products/selexaim.png";
import selexaim1 from "../images/products/selexaim1.png";
import selexflare from "../images/products/selexflare.png";
import selexflare1 from "../images/products/selexflare1.png";


import selexvf from "../images/products/selexvf.png";
import selexvf1 from "../images/products/selexvf1.png";

import selexreliability from "../images/products/selexreliability.png";
import selexreliability1 from "../images/products/selexreliability1.png";
import selexleak1 from "../images/products/selexleak1.png";
import selexleak from "../images/products/selexleak.png";

import selexeca from "../images/products/selexeca.png";
import selexeca1 from "../images/products/selexeca1.png";

import selexnode from "../images/products/selexnode.png";
import selexnode1 from "../images/products/selexnode1.png";

import SelexRiskLogo from "../images/SelexRISK.png";
import SelectSelexMath from "./SelectSelexMath";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Footer from "./Footer";

const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#061d34";

const apps = [
  {
    name: "SelexNode",
    route: "#",
    logo: selexnode,
    icon: <MonitorHeartIcon />,
    tag: "Predictive Risk & CBM​",
    challenges:["PHA studies, HAZOP/LOPA studies live in disconnected worksheets; actions and SIL decisions get lost.​","Risk ranking is inconsistent and hard to defend to regulators and auditors.​","Producing PHA reports is slow and manual.​"],
    values:["Structured PHA, HAZOP, LOPA and QRA in one workspace (IEC 61882) with a consistent matrix.​","Transparent SIL allocation with traceable safeguards and actions.​","Branded, audit-ready PHA reports generated automatically.​"],
    desc: "Hybrid Process hazard Analysis, HAZOP/LOPA/QRA with risk matrix, SIL and PHA reporting. Excellent platform empowering operation to run safely​​",
    descimg:selexnode1
  },
  {
    name: "SelexORACLE",
    route: "/selexoracle",
    logo: selexoracle,
    icon: <MonitorHeartIcon />,
    tag: "Condition Monitoring",
    challenges:["Unplanned shutdowns are the single largest source of lost production and safety risk in process plants.​","Fixed-schedule maintenance wastes money servicing healthy equipment while real failures develop unseen between inspections.​","Operations teams have no reliable way to know when the next trip or failure will happen.​"],
    values:["SelexORACLE learns from your plant's own historical data to forecast when the next shutdown or trip is likely to occur. ​","Moves your team from reactive firefighting to planned intervention higher uptime, fewer surprises, lower maintenance cost.​"],
    desc: "Predictive-maintenance & shutdown forecasting using ML models to act before failure occurs.​",
    descimg:selexoracle1
  },
 
  {
    name: "SelexPyramis",
    route: "#",
    logo: selexpyramis,
    icon: <LocalFireDepartmentIcon />,
    tag: "Consequence Modeling",
    desc: "QRA & TRA unified platform for Risk Assessment​",
    challenges:["Incidents and near-misses are logged but rarely turned into forward insight.​","Organisations react to lagging indicators after the harm, not before.​","Safety performance trends stay buried in incident databases.​"],
    values:["Converts incident and near-miss data into leading process-safety indicators.​","Reveals where the next major event is most likely to originate.​","Empower leadership act on risk before it climbs the safety pyramid.​"],
    descimg:selexpyramis1
  },
  {
    name: "SelexAIM",
    route: "#",
    logo: selexaim,
    icon: <TrackChangesIcon />,
    tag: "Asset Integrity",
    desc: "Asset-integrity & failure-prediction tool with IOW monitoring and prioritised maintenance recommendations.​",
    challenges:["Aging assets fail with little warning as integrity threats build up unseen.​","Operating outside safe windows (IOWs) silently accelerates damage.​","Inspection effort isn’t focused where degradation is fastest.​"],
    values:["Predicts failures and tracks integrity operating windows in real time.​","Flags excursions that accelerate damage before loss of containment.​","Prioritised maintenance recommendations focus effort where it matters.​"],
    descimg:selexaim1
  },
  {
    name: "SelexReliability",
    route: "#",
    logo: selexreliability,
    icon: <EngineeringIcon />,
    tag: "Reliability Analytics",
    desc: "Integrated FTA, FMECA & LOPA platform for quantifying reliability and defining risk-reduction safeguards.​",
    challenges:["Reliability and safeguard decisions are made on judgement, not quantified risk.​","Failure modes aren’t systematically linked to their protection layers.​","Hard to justify where to invest in redundancy or barriers.​"],
    values:["Quantifies system reliability with integrated FTA, FMECA and LOPA.​","Pinpoints dominant failure modes and the safeguards that truly reduce risk.​","Defensible basis for redundancy, sparing and barrier investment.​"],
    descimg:selexreliability1
  },
  {
    name: "SelexLEAK",
    route: "#",
    logo: selexleak,
    icon: <EngineeringIcon />,
    tag: "Reliability Analytics",
    desc: "Specialist Consequence Modeling platform integrated with ROM to support AI-enabled projects​",
    challenges:["Fugitive emissions and leaks drive regulatory exposure, lost product and HSE risk.​","LDAR campaigns are manual, paperwork-heavy and hard to prioritise.​","Methane and VOC reporting demands defensible, auditable data.​"],
    values:["Manages leak-detection and LDAR campaigns with prioritised, auditable workflows.​","Targets the biggest emission and loss sources first.​","Supports emission reduction and compliance reporting.​"],
    descimg:selexleak1
  },
  {
    name: "SelexVF",
    route: "#",
    logo: selexvf,
    icon: <EngineeringIcon />,
    tag: "Reliability Analytics",
    desc: "API 521 screening tool for fire-exposed vessels and piping. It converts process, fire, metallurgy and PFP data into a clear survivability verdict and protection basis.​​",
    challenges:["Fire-exposed vessels / piping can rupture before blowdown safely relieves pressure.​ Manual survivability checks are slow, fragmented and hard to defend during design review.​ Fire type, metal temperature, wall thinning, material derating and PFP adequacy interact dynamically.​ Teams need fast scenario comparison to screen escalation risk and define the required protection basis"],
    values:["One integrated workflow for API 521 Annex A vessel survivability screening.​ Calculates heat-up, pressure decay, UT stress, strength derating and the stress-vs-strength crossover.​ Produces a traceable verdict with governing time-to-failure, peak wall temperature, minimum margin and PFP / depressuring actions.​"],
    descimg:selexvf1
  },
  {
    name: "SelexECA",
    route: "/selexeca",
    logo: selexeca,
    icon: <EngineeringIcon />,
    tag: "Reliability Analytics",
    desc: "Equipment Criticality Assessment that ranks assets by risk to focus inspection and maintenance spend.​",
    challenges:["Limited inspection and maintenance budgets are spread thinly across thousands of assets.​","Without risk ranking, effort goes to the wrong kit and critical items are under-protected.​","Criticality assessments are inconsistent and quickly outdated.​"],
    values:["Ranks every asset by risk and criticality to focus inspection and maintenance spend.​","Directs limited resources to the equipment most critical to safety and production.​","Consistent, repeatable basis for RBI and maintenance strategy.​"],
    descimg:selexeca1
  },
   {
    name: "SelexFlare",
    route: "#",
    logo: selexflare,
    icon: <AccountTreeIcon />,
    tag: "Dynamic Flare System​",
    challenges:["Multiple relief sources create complex flow paths and variable backpressure.​","Changing loads and compositions affect cooling, condensation and flow behavior.​","Separate calculations make scenario comparison and reporting time-consuming.​"],
    values:["Builds 3D flare networks with simple sources and time-based load profiles.​","Dynamic Calculation of the network backpressure, fluid temperatures, phase behavior and flow regimes.​","Combines visual results, AIV and radiation screening, and Excel reporting.​"],
    desc: "SelexFlare integrates thermodynamics, 3D flare network modeling, hydraulics, heat transfer, and radiation screening with visual results and comprehensive engineering reports.​",
    descimg:selexflare1
  },
];

function SelectSelexRisk() {
  const [openAppModal, setOpenAppModal] = React.useState(false);
  const [selectedApp, setSelectedApp] = React.useState(null);
  const [demoOpen, setDemoOpen] = React.useState(false);
  const [demoForm, setDemoForm] = React.useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });
  
  const isLoggedIn = !!sessionStorage.getItem("usertoken");
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleAppClick = (app) => {
    setSelectedApp(app);
    setOpenAppModal(true);
  };
  
  const handleCloseAppModal = () => {
    setOpenAppModal(false);
    setSelectedApp(null);
  };
  const handleDemoChange = (e) => {
    setDemoForm({
      ...demoForm,
      [e.target.name]: e.target.value,
    });
  };
  
const handleDemoSubmit = async () => {
  try {
    const response = await fetch(`${baseURL}/request-demo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...demoForm,
        to: "safiyanaaz@optimizegs.com",
      }),
    });

    if (response.ok) {
      alert("Demo Request for SelexRISK Submitted Successfully");
      setDemoOpen(false)
    } else {
      alert("Failed to submit request");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");

  }
};
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#fff",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>
            

      <Box
        sx={{
          width: "min(1280px, calc(100% - 32px))",
          mx: "auto",
          pt: { xs: 15, md: 18 },
          pb: 8,
        }}
      >
        {/* HERO */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            gap: 4,
            alignItems: "center",
            mb: { xs: 6, md: 8 },
          }}
        >
          <Box>
            <Box
              component="img"
              src={SelexRiskLogo}
              alt="SelexRisk"
              sx={{ width: 135, maxHeight: 125, objectFit: "contain", mb: 2 }}
            />

            <Typography
              component="h1"
              sx={{
                fontSize: { xs: 40, sm: 54, md: 72 },
                lineHeight: 0.96,
                fontWeight: 950,
                letterSpacing: { xs: "-1.8px", md: "-3.4px" },
                color: navy,
                mb: 2,
              }}
            >
              Explore powerful <Box component="span" sx={{ color: primary }}>Selex</Box>
              <Box component="span" sx={{ color: accent }}>RISK™</Box> apps
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 15, md: 18 },
                color: "#64748b",
                lineHeight: 1.8,
                maxWidth: 760,
                mb: 3.5,
              }}
            >
              A modern process safety and reliability ecosystem for failure prediction, anomaly detection, HAZOP studies, consequence modeling, asset integrity, and risk-based decision support.
            </Typography>

            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
              <Button href="#risk-apps" endIcon={<ArrowForwardIcon />} sx={primaryBtn}>
                View Risk Applications
              </Button>
              <Button onClick={() => setDemoOpen(true)} sx={outlineBtn}>
                Request Demo
              </Button>
            </Box>
          </Box>

          {/* HERO DASHBOARD */}
          <Box
  id="risk-overview"
  sx={{
    position: "relative",
    borderRadius: "34px",
    p: { xs: 3, md: 4 },
    background:
      "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",
    backdropFilter: "blur(18px)",
    overflow: "hidden",
    border: "1px solid rgba(0,120,201,0.16)",
    boxShadow: "0 24px 60px rgba(0,120,201,0.10)",

  }}
>
  <Box sx={{ position: "relative", zIndex: 2 }}>
    <Typography
      sx={{
        fontSize: 14,
        color: "#9e0b22",
        fontWeight: 800,
        mb: 1,
        letterSpacing: 1,
      }}
    >
      RISK INTELLIGENCE COVERAGE
    </Typography>

    <Typography
      sx={{
        fontSize: { xs: 34, md: 46 },
        fontWeight: 950,
        lineHeight: 1,
        mb: 3,
        color: "#0078c9",
      }}
    >
      9 Apps. 1 Safety Ecosystem.
    </Typography>

    <Box sx={{ display: "grid", gap: 1.5 }}>
      {[
        [
          "Prediction",
          "PoF, anomaly detection, reliability and failure likelihood",
        ],
        [
          "Safety Studies",
          "HAZOP, consequence modeling and process hazard analysis",
        ],
        [
          "Asset Integrity",
          "Condition monitoring, risk visibility and decision support",
        ],
      ].map(([title, desc]) => (
        <Box
          key={title}
          sx={{
            p: 2,
            borderRadius: "18px",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.92), rgba(248,251,255,0.88))",
            border: "1px solid rgba(0,120,201,0.12)",
            boxShadow: "0 10px 28px rgba(0,120,201,0.06)",
            transition: ".3s",

            "&:hover": {
              transform: "translateY(-3px)",
              borderColor: "#0078c9",
              boxShadow: "0 18px 40px rgba(0,120,201,0.12)",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 900,
              color: "#0078c9",
              mb: 0.4,
              fontSize: 16,
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              fontSize: 13,
              color: "#64748b",
              lineHeight: 1.6,
            }}
          >
            {desc}
          </Typography>
        </Box>
      ))}
    </Box>

    <Box
      sx={{
        mt: 3,
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 1,
      }}
    >
      {["LOW", "MED", "HIGH"].map((risk, i) => (
        <Box
          key={risk}
          sx={{
            p: 1.3,
            borderRadius: "15px",
            textAlign: "center",
            fontSize: 12,
            fontWeight: 950,
            color: "#0078c9",
            background:
              i === 0
                ? "rgba(62, 232, 99, 0.08)"
                : i === 1
                ? "rgba(235, 224, 22, 0.05)"
                : "rgba(158,11,34,0.08)",
            border:
              i === 2
                ? "1px solid rgba(158,11,34,0.18)"
                : "1px solid rgba(0,120,201,0.14)",
          }}
        >
          {risk} RISK
        </Box>
      ))}
    </Box>
  </Box>
</Box>
        </Box>

        {/* SECTION TITLE */}
        <Box sx={{ textAlign: "center", mb: 4 }} id="risk-apps">
          <Typography sx={{ color: accent, fontSize: 12, fontWeight: 950, letterSpacing: 1.2, textTransform: "uppercase", mb: 1 }}>
            Applications
          </Typography>
          <Typography sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 950, color: navy, letterSpacing: "-1.4px", mb: 1.5 }}>
            Select a SelexRISK™ solution
          </Typography>
          <Typography sx={{ color: "#64748b", maxWidth: 760, mx: "auto", lineHeight: 1.75 , fontSize:14 }}>
            Choose the application that fits your process safety, equipment reliability, hazard analysis, or predictive risk workflow.
          </Typography>
        </Box>

        {/* APPS GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "repeat(3, 1fr)" },
            gap: 3,
          }}
        >
          {apps.map((app, index) => (
  <Box
    key={app.name}
    onClick={() => handleAppClick(app)}
    sx={{
      textDecoration: "none",
      position: "relative",
      minHeight: 300,
      p: 3,
      borderRadius: "30px",
      cursor: "pointer",
      overflow: "hidden",

      background:
        "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",

      border: "1px solid rgba(0,120,201,0.16)",
      boxShadow: "0 18px 48px rgba(0,120,201,0.10)",
      transition: "0.35s ease",

      "&:hover": {
        transform: "translateY(-10px)",
        boxShadow: "0 28px 75px rgba(0,120,201,0.18)",
        borderColor: primary,
      },

    }}
  >
    <Box sx={{ position: "relative", zIndex: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 3,
        }}
      >
        <Box
          sx={{
            width: 76,
            height: 76,
            borderRadius: "22px",
            bgcolor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid rgba(0,120,201,0.12)",
            boxShadow: "0 14px 34px rgba(0,120,201,0.10)",
            overflow: "hidden",
          }}
        >
          <Box
            component="img"
            src={app.logo}
            alt={app.name}
            sx={{
              width: 54,
              maxHeight: 54,
              objectFit: "contain",
            }}
          />
        </Box>

      </Box>

      <Chip
        label={app.tag}
        size="small"
        sx={{
          bgcolor: "rgba(158,11,34,0.08)",
          color: accent,
          border: "1px solid rgba(158,11,34,0.12)",
          fontWeight: 800,
          mb: 2,
          fontSize:12

        }}
      />

      <Typography
        sx={{
          fontSize: 24,
          fontWeight: 950,
          color: primary,
          mb: 1.2,
        }}
      >
        {app.name}
      </Typography>

      <Typography
        sx={{
          fontSize: 14,
          color: "#64748b",
          lineHeight: 1.75,
          mb: 3,
        }}
      >
        {app.desc}
      </Typography>

      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.8,
          color: primary,
          fontWeight: 900,
          fontSize: 14,
        }}
      >
        About <ArrowForwardIcon sx={{ fontSize: 17 }} />
      </Box>
    </Box>
  </Box>
))}
        </Box>



                   <Modal open={openAppModal} onClose={handleCloseAppModal}>
  <Box
    sx={{
      width: { xs: "92%", md: 1600 },
      bgcolor: "#fff",
      borderRadius: "18px",
      p: 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "0px 22px 65px rgba(6,29,52,0.22)",
      //border: "1px solid rgba(0,120,201,0.18)",
      overflow: "hidden",
    }}
  >
    {selectedApp && (
      <>
        {/* TOP BAR */}
        <Box
          sx={{
            height: 18,
            background: "linear-gradient(90deg,#061d34,#0078c9)",
          }}
        />

        <Box
          sx={{
            p: { xs: 2.5, md: 4 },
            display: "grid",
            gridTemplateColumns: {
  xs: "1fr",
  md: "250px 360px 1fr",
},
            gap: 3,
          }}
        >
          {/* LEFT PRODUCT CARD */}
          <Box component={Paper}
          elevation ={0} sx={{borderRadius: "18px"}}>
            <Box
              sx={{
                borderRadius: "18px",
                //border: "1px solid rgba(0,120,201,0.14)",
                overflow: "hidden",
                boxShadow: "0 14px 34px rgba(0,120,201,0.10)",
                height:"470px",
              }}
            >
            <Typography
              sx={{
                fontSize: { xs: 24, md: 24 },
                fontWeight: 950,
                color: "#fff",
                background:"#0078c9",
                mb: 2.5,
                px: 2,
                  py: 1.2,
              }}
            >
              {selectedApp.name}
            </Typography>
             

              <Box sx={{ p: 2.5 }}>
                <Box
                  sx={{
                    width: 76,
                    height: 76,
                    borderRadius: "50%",
                    bgcolor: "#f8fbff",
                    border: "1px solid #d9e9f7",
                    display: "grid",
                    placeItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={selectedApp.logo}
                    alt={selectedApp.name}
                    sx={{
                      width: 52,
                      maxHeight: 52,
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#0078c9",
                    fontWeight: 800,
                    mb: 1,
                  }}
                >
                  {selectedApp.tag}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#061d34",
                    lineHeight: 1.7,
                    fontStyle: "italic",
                  }}
                >
                  {selectedApp.desc}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* RIGHT CONTENT */}
          <Box
          component={Paper}
          elevation ={1}
          sx={{height:"470px",border:"1px solid #fff",borderRadius: "14px"}}
          >
            

            {/* INDUSTRIAL CHALLENGES */}
            <Box
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                mb: 2,
                //border: "1px solid rgba(158,11,34,0.16)",
              }}
            >
              <Box
                sx={{
                  background: "#b42325",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  fontSize: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Industrial Challenges
              </Box>

              <Box sx={{ p: 2 }}>
                {(selectedApp.challenges).map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: 13,
                      color: "#061d34",
                      lineHeight: 1.7,
                      mb: 1,
                    }}
                  >
                    ▪ {item}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* VALUE PROPOSITION */}
            <Box
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                //border: "1px solid rgba(0,120,201,0.16)",
              }}
            >
              <Box
                sx={{
                  background: "#2878bd",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  fontSize: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Product Value Proposition
              </Box>

              <Box sx={{ p: 2 }}>
                {(selectedApp.values).map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: 13,
                      color: "#061d34",
                      lineHeight: 1.7,
                      mb: 1,
                    }}
                  >
                    ▪ {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>

          <Box>
                                    {selectedApp.descimg?.endsWith(".mp4") ? (
                         <Box
                           component="video"
                           src={selectedApp.descimg}
                           controls
                           autoPlay
                           muted
                           loop
                           sx={{
                             width: 900,
                             height: "470px",
                             objectFit: "contain",
                           }}
                         />
                       ) : (
                         <Box
                           component="img"
                           src={selectedApp.descimg}
                           alt={selectedApp.name}
                           sx={{
                             width: 900,
                             height: "470px",
                             objectFit: "contain",
                           }}
                         />
                       )}
          </Box>
        </Box>

        {/* FOOTER ACTIONS */}
        <Box
          sx={{
            px: { xs: 2.5, md: 4 },
            py: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            borderTop: "1px solid rgba(0,120,201,0.10)",
            background: "#f8fbff",
          }}
        >
          <Button
            onClick={handleCloseAppModal}
            variant="outlined"
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontSize: "12px",
              fontWeight: 700,
              color: "#0078c9",
              borderColor: "#0078c9",
              "&:hover": {
                borderColor: "#9e0b22",
                color: "#9e0b22",
              },
            }}
          >
            Close
          </Button>

          {isLoggedIn ? (
            <Button
              component="a"
              href={selectedApp.route}
              variant="contained"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "12px",
                fontWeight: 700,
                background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
                "&:hover": {
                  background: "#9e0b22",
                  color: "#fff",
                },
              }}
            >
              Go to {selectedApp.name} App
            </Button>
          ):(
                           <Button
                                   onClick={() =>
                          navigate("/login", {
                            state: { from: selectedApp.route }
                          })
                        }
                                    sx={{
                                      width: 140,
                                      height: 44,
                                      borderRadius: "14px",
                                      background: "linear-gradient(135deg, #005da0, #005da0)",
                                      color: "#fff",
                                      transition: "0.3s",
                                      textTransform: "none",
                                      fontWeight: 700,
                                      fontSize:14,
                                
                                      "&:hover": {
                                        background: "#9e0b22",
                                        color: "#fff",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                  >
                                    Login
                                  </Button>
                    )}
        </Box>
      </>
    )}
  </Box>
</Modal>
        
        <Modal open={demoOpen} onClose={() => setDemoOpen(false)}>
          <Box
            sx={{
              width: 430,
              bgcolor: "#fff",
              borderRadius: "26px",
              p: 3,
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: "0px 18px 55px rgba(6,29,52,0.18)",
              border: "1px solid rgba(0,120,201,0.14)",
            }}
          >
            <Typography sx={{ fontSize: 22, fontWeight: 900, color: "#0078c9", mb: 1 }}>
              Request Demo
            </Typography>
        
            <Typography sx={{ fontSize: 14, color: "#64748b", mb: 2 }}>
              Fill your details and our team will contact you.
            </Typography>
        
            {[
              { label: "Full Name", name: "name" },
              { label: "Business Email", name: "email" },
              { label: "Phone", name: "phone" },
              { label: "Company", name: "company" },
               { label: "Product", name: "product" },
              { label: "Message", name: "message", multiline: true },
            ].map((field) => (
              <TextField
                key={field.name}
                fullWidth
                size="small"
                label={field.label}
                name={field.name}
                multiline={field.multiline}
                rows={field.multiline ? 3 : 1}
                value={demoForm[field.name]}
                onChange={handleDemoChange}
                sx={{
                  mb: 1.5,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    fontSize: "14px",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "13px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#d9e9f7",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#9e0b22",
                  },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0078c9",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#0078c9",
                  },
                }}
              />
            ))}
        
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
              <Button
                onClick={() => setDemoOpen(false)}
                variant="outlined"
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  color: "#0078c9",
                  borderColor: "#0078c9",
                  fontSize:"14px",
                }}
              >
                Cancel
              </Button>
        
              <Button
                onClick={handleDemoSubmit}
                variant="contained"
                sx={{
                  borderRadius: "12px",
                  fontSize:"14px",
                  textTransform: "none",
                  background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                  boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
                  "&:hover": {
                    background: "#9e0b22",
                  },
                }}
              >
                Send Request
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* RISK WORKFLOW */}
        <Box sx={{ py: { xs: 7, md: 10 } }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography sx={{ color: accent, fontSize: 12, fontWeight: 950, letterSpacing: 1.2, textTransform: "uppercase", mb: 1 }}>
              Risk Engineering Workflow
            </Typography>
            <Typography sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 950, color: navy, letterSpacing: "-1.4px", mb: 1.5 }}>
              From hazard identification to risk action
            </Typography>
            <Typography sx={{ color: "#64748b", maxWidth: 780, mx: "auto", lineHeight: 1.75 , fontSize:14 }}>
              SelexRISK helps teams structure risk studies, quantify likelihood and consequences, prioritize actions, and document safety decisions clearly.
            </Typography>
          </Box>

          <Box sx={workflowWrapStyle}>
            {["Identify", "Analyze", "Quantify", "Prioritize", "Mitigate", "Report"].map((step, index) => (
              <Box key={step} sx={workflowStepStyle(index)}>
                <Typography sx={{ position: "relative", zIndex: 2, color: accent, fontSize: 12, fontWeight: 950, mb: 0.8 }}>
                  0{index + 1}
                </Typography>
                <Typography sx={{ position: "relative", zIndex: 2, fontSize: 16, fontWeight: 950 }}>
                  {step}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* APPLICATIONS + WHY */}
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" }, gap: 3, pb: { xs: 7, md: 10 } }}>
          <Box sx={largeWhitePanel}>
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Typography sx={{ color: accent, fontSize: 18, fontWeight: 950, letterSpacing: 1, mb: 1 }}>
                Industrial Safety Applications
              </Typography>
              <Typography sx={{ color: primary, fontSize: { xs: 28, md: 38 }, fontWeight: 950, mb: 2, letterSpacing: "-1px" }}>
                Built for real process safety studies
              </Typography>
              <Typography sx={{ color: "#0f172a", lineHeight: 1.8, mb: 3 , fontSize:14 }}>
                SelexRISK supports engineering teams working across process safety, reliability, asset integrity, HAZOP studies, consequence analysis, and predictive maintenance programs.
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.2 }}>
                {[
                  "Oil & Gas Facilities",
                  "Process Safety",
                  "Asset Integrity",
                  "HAZOP Studies",
                  "Reliability Engineering",
                  "Predictive Maintenance",
                  "Consequence Modeling",
                  "Risk-Based Inspection",
                ].map((tag) => (
                  <Chip key={tag} label={tag} sx={blueChipStyle} />
                ))}
              </Box>
            </Box>
          </Box>

          <Box sx={whyPanelStyle}>
            <Typography sx={{ color: accent, fontSize: 18, fontWeight: 950, letterSpacing: 1, mb: 1 }}>
              Why SelexRISK?
            </Typography>
            <Typography sx={{ color: primary, fontSize: { xs: 28, md: 38 }, fontWeight: 950, mb: 3, letterSpacing: "-1px" }}>
              Smarter than static risk sheets
            </Typography>

            <Box sx={{ display: "grid", gap: 1.5 }}>
              {[
                ["Predict Failures Before They Happen", "Proactive Shutdown Forecasting"],
                ["Intelligent IOW Monitoring", "Prioritized Maintenance Recommendations"],
                ["Professional HAZOP Platform", "Unified QRA & TRA Environment"],
                ["Data-Driven Reliability Engineering", "Reduce Risk While Optimizing Cost"],
              ].map(([before, after]) => (
                <Box key={before} sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1.2 }}>
                  <Box sx={compareGood}>{before}</Box>
                  <Box sx={compareGood}>{after}</Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

      </Box>
      <Footer />
    </Box>
  );
}

const primaryBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  background: `linear-gradient(135deg, ${primary}, #005b98)`,
  color: "#fff",
    fontSize:14,

  fontWeight: 900,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: `linear-gradient(135deg, ${accent}, #75081a)`,
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
    color:"#fff"
  },
};

const outlineBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  color: primary,
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  background: "#fff",
  border: "1px solid rgba(0,120,201,0.25)",
  "&:hover": {
    color: accent,
    borderColor: accent,
    background: "rgba(158,11,34,0.04)",
    transform: "translateY(-2px)",
  },
};

const darkGlassBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  color: "#fff",
  fontWeight: 900,
  textTransform: "none",
  background: "rgba(255,255,255,0.08)",
  border: "1px solid rgba(255,255,255,0.18)",
  "&:hover": {
    background: "rgba(255,255,255,0.14)",
    transform: "translateY(-2px)",
  },
};

const workflowWrapStyle = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(6, 1fr)" },
  gap: 2,
  p: { xs: 2, md: 3 },
  borderRadius: "34px",
  background: "#fff",
  border: "1px solid rgba(0,120,201,0.12)",
  boxShadow: "0 18px 55px rgba(6,29,52,0.08)",
};

const workflowStepStyle = (index) => ({
  minHeight: 118,
  borderRadius: "24px",
  p: 2,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  background: "#fff",
  color: primary,
  position: "relative",
  overflow: "hidden",
  border: "1px solid navy",
  boxShadow: "0 10px 26px rgba(6,29,52,0.06)",
  
});

const largeWhitePanel = {
  p: { xs: 3, md: 4 },
  borderRadius: "34px",
  background: "#fff",
  color: "#fff",
  boxShadow: "0 24px 70px rgba(6,29,52,0.14)",
  border: "1px solid navy",
  position: "relative",
  overflow: "hidden",

};

const whyPanelStyle = {
  p: { xs: 3, md: 4 },
  borderRadius: "34px",
  background: "#fff",
  border: "1px solid navy",
  boxShadow: "0 18px 55px rgba(6,29,52,0.08)",
};

const blueChipStyle = {
  bgcolor: primary,
  fontSize: 15,
  color: "#fff",
  border: "1px solid rgba(255,255,255,0.12)",
  fontWeight: 800,
};


const compareGood = {
  p: 1.8,
  borderRadius: "18px",
  bgcolor: "rgba(0,120,201,0.07)",
  color: navy,
  border: "1px solid rgba(0,120,201,0.16)",
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.5,
};

const ctaStyle = {
  mb: 8,
  p: { xs: 3.5, md: 5.5 },
  textAlign: "center",
  borderRadius: "34px",
  background:
    "radial-gradient(circle at top left, rgba(0,120,201,0.30), transparent 35%), radial-gradient(circle at top right, rgba(158,11,34,0.35), transparent 32%), linear-gradient(135deg, #061d34, #03111f)",
  border: "1px solid rgba(0,120,201,0.18)",
  boxShadow: "0 24px 70px rgba(6,29,52,0.22)",
};

export default SelectSelexRisk;
